export var shellOptions = {
    meControlOptions: {
        apiGeneration: 'GEN2',
        authProviderConfig: {
            type: 'webAadOnly',
            appSignInUrl: 'https://www.microsoft.com/cascadeauth/account/signin',
            appSignInToUrl: 'https://www.microsoft.com/digitalsafety',
            appSignOutUrl: 'https://www.microsoft.com/digitalsafety',
            appSwitchUrl: 'https://www.microsoft.com/digitalsafety',
            appSwitchToUrl: 'https://www.microsoft.com/digitalsafety',
            msa: {
                signOutAndForgetUrl: 'https://www.microsoft.com/digitalsafety',
                rememberedAccountsUrl: 'https://www.microsoft.com/digitalsafety',
            },
            aad: {
                signOutUrl: 'https://www.microsoft.com/digitalsafety',
                signOutAndForgetUrl: 'https://www.microsoft.com/digitalsafety',
                signOutAndForgetMsaFedUrl: 'https://www.microsoft.com/digitalsafety',
                rememberedAccountsUrl: 'https://www.microsoft.com/digitalsafety',
            }
        }
    }
};
